import { useEffect, useState } from "react";
import Select from "react-select";
import { Pagination } from "@mui/material";

// components
import LoadList from "../../components/LoadList";
import SearchStuff from "../../components/SearchStuff";
import LoadsFilter from "./LoadsFilter";
import SearchDates from "../../components/SearchDates";

// store
import { projectStore } from "../../store/Store";

// styles and images
import "./Project.css";
import Lock from "../../assets/lock.svg";
// hooks
import { useGetUniqueOptions } from "../../hooks/useGetUniqueOptions";
import { loadApprovalStatus } from "../../data/collections-data";

export default function AssetLoads({
  setLoadLockTrigger,
  setIsAsset,
  setLockEndpoint,
}) {
  // global
  const projectAssetLoads = projectStore((data) => data.projectAssetLoads);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices,
  );

  // local
  const [perPage, setPerPage] = useState(25);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [paginatedLoads, setPagninatedLoads] = useState(projectAssetLoads);
  const [carrierDD, setCarrierDD] = useState(null);
  const [customerInvoiceDD, setCustomerInvoiceDD] = useState([]);
  const [loadsSearch, setLoadsSearch] = useState([]);
  const [loadsFilter, setLoadsFilter] = useState(projectAssetLoads);
  const [currFilter, setCurrFilter] = useState("all");
  const [filterOptions, setFilterOptions] = useState({
    load: "",
    carrier: "",
    customer_invoice: "",
    approval_status: "",
  });
  const pageOptions = [
    {
      value: 10,
      label: 10,
    },
    {
      value: 25,
      label: 25,
    },
    {
      value: 100,
      label: 100,
    },
  ];
  useGetUniqueOptions(setCarrierDD, projectAssetLoads, "carrier_name");

  useEffect(() => {
    const versions = [];
    const mainId = [];
    const invoices = [{ value: 0, label: "All" }];
    if (projectCustomerInvoices) {
      // get the main id's and all of the version ids
      projectCustomerInvoices.forEach((i) => {
        if (i.is_main && i.is_asset) {
          versions.push(i.id);
          mainId.push(i.id);
        } else {
          versions.push(i.version_of);
        }
      });
      // extract the last version created for each main invoice
      mainId.forEach((m) => {
        const idx = versions.lastIndexOf(m);
        invoices.push({
          value: projectCustomerInvoices[idx].id,
          label: projectCustomerInvoices[idx].invoice_name,
        });
      });
    }
    setCustomerInvoiceDD(invoices);
  }, [projectCustomerInvoices, setCustomerInvoiceDD]);

  const selectPage = (_, p) => {
    setPage(p);
  };

  const selectPerPage = (k, _) => {
    setPerPage(k.label);
    setPage(1);
  };

  useEffect(() => {
    if (projectAssetLoads) {
      if (loadsSearch.length === 0) {
        const loadsLength = loadsFilter.length;
        setCount(Math.ceil(loadsLength / perPage));
      } else {
        const loadsLength = loadsSearch.length;
        setCount(Math.ceil(loadsLength / perPage));
      }
    }
  }, [
    projectAssetLoads,
    perPage,
    setCount,
    loadsSearch.length,
    loadsFilter.length,
  ]);

  useEffect(() => {
    setLoadsFilter(projectAssetLoads);
  }, [projectAssetLoads]);

  useEffect(() => {
    var pageLoads = page * perPage;
    var previousPage = page - 1;
    var prevLoads;
    if (previousPage === 0) {
      prevLoads = 1;
    } else {
      prevLoads = previousPage * perPage;
    }
    if (projectAssetLoads) {
      if (loadsSearch.length === 0) {
        const loadsLength = loadsFilter.length;
        if (pageLoads >= loadsLength) {
          if (page === 1) {
            setPagninatedLoads(loadsFilter.slice(0, loadsLength));
          } else {
            setPagninatedLoads(loadsFilter.slice(prevLoads, loadsLength));
          }
        } else {
          setPagninatedLoads(loadsFilter.slice(prevLoads - 1, page * perPage));
        }
      } else {
        const loadsLength = loadsSearch.length;
        if (pageLoads >= loadsLength) {
          if (page === 1) {
            setPagninatedLoads(loadsSearch.slice(0, loadsLength));
          } else {
            setPagninatedLoads(loadsSearch.slice(prevLoads, loadsLength));
          }
        } else {
          setPagninatedLoads(loadsSearch.slice(prevLoads - 1, page * perPage));
        }
      }
    }
  }, [
    page,
    loadsSearch,
    setPagninatedLoads,
    perPage,
    projectAssetLoads,
    loadsFilter,
  ]);

  const handleLock = () => {
    setLoadLockTrigger(true);
    setIsAsset(true);
    setLockEndpoint("asset-load");
  };

  return paginatedLoads && projectAssetLoads ? (
    <div className="col-auto">
      <div className="col-auto">
        <div className="d-flex justify-content-between card-header">
          <LoadsFilter
            setLoadsFilter={setLoadsFilter}
            setFilterOptions={setFilterOptions}
            setLoadsSearch={setLoadsSearch}
            isAsset={true}
            currFilter={currFilter}
            setCurrFilter={setCurrFilter}
          />
        </div>
        <div className="d-flex justify-content-between">
          <div className="search-stuff-inputs">
            <SearchStuff
              data={projectAssetLoads}
              field={"load_no"}
              label={"Loads"}
              type={"number"}
              setState={setLoadsSearch}
              name={"load"}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
            />
          </div>
          <div className="search-stuff-inputs">
            <SearchStuff
              data={projectAssetLoads}
              field={"carrier_name"}
              setState={setLoadsSearch}
              name={"carrier"}
              isSelect={true}
              options={carrierDD}
              selectPlaceholder={"Select Carrier"}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
            />
          </div>
          <div className="search-stuff-inputs">
            <SearchStuff
              data={projectAssetLoads}
              field={"customer_invoice_id"}
              setState={setLoadsSearch}
              name={"customer_invoice"}
              isSelect={true}
              options={customerInvoiceDD}
              selectPlaceholder={"Select Invoice"}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
              useValue={true}
            />
          </div>
          <div className="search-stuff-inputs">
            <SearchStuff
              data={projectAssetLoads}
              field={"propconnect_approval_status"}
              setState={setLoadsSearch}
              name={"approval_status"}
              isSelect={true}
              options={loadApprovalStatus}
              selectPlaceholder={"Select Status"}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
              useValue={false}
            />
          </div>
          <SearchDates data={projectAssetLoads} setState={setLoadsSearch} />
          <div className="col-auto" style={{ margin: "0 0 0 20px" }}>
            <img
              src={Lock}
              alt="lock"
              onClick={handleLock}
              className="project-filter-image"
            />
          </div>
        </div>
      </div>
      <div className="load-display-list">
        <table className="table table-sm table-hover">
          <thead>
            <tr>
              <th>Load</th>
              <th>Type</th>
              <th>Delivery Date</th>
              <th>Carrier</th>
              <th>Driver</th>
              <th>Mileage</th>
              <th>Total Boxes</th>
              <th>Weight (tons)</th>
              <th>Freight Rev ($)</th>
              <th>FSC Rev ($)</th>
              <th>Freight Cost ($)</th>
              <th>FSC Cost ($)</th>
              <th>Locked</th>
              <th>Invoiced</th>
              <th>Approval Status</th>
            </tr>
          </thead>
          <tbody>
            <LoadList deliveredLoads={paginatedLoads} isAsset={true} />
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          margin: "20px",
        }}
      >
        <Select
          key={"per-page"}
          options={pageOptions}
          onChange={selectPerPage}
          placeholder={perPage}
        />
        <Pagination count={count} variant="outlined" onChange={selectPage} />
      </div>
    </div>
  ) : (
    <p>No Asset Loads have been delivered...</p>
  );
}
